<!--
 * @Author: DQL
 * @Date: 2021-01-05 00:02:56
 * @LastEditors: DQL
 * @LastEditTime: 2021-05-06 11:39:40
 * @Description: file content
-->
<template>
  <el-dialog
    class="o-no-modal-bg o-dialog o-dialog--sm o-dialog--md-70 o-dialog--lg-70 o-dialog--xl-50"
    title="修改密码"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <section>
      <el-form
        ref="fd"
        class="c-form"
        :model="fd"
        :rules="fdRules"
        :inline="true"
        label-position="right"
        label-width="120px"
        label-suffix="："
      >
        <el-row
          class="c-form__row"
        >
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="原密码"
              prop="oldPwd"
            >
              <el-input
                v-model="fd.oldPwd"
                class="c-form__input"
                type="password"
                placeholder="请输入原密码"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="新密码"
              prop="newPwd"
            >
              <el-input
                v-model="fd.newPwd"
                class="c-form__input"
                type="password"
                placeholder="请输入新密码"
              />
              <check-pwd-progress
                class="u-mg-t-8"
                progress-title="密码强度："
                :show-title="true"
                :text-inside="true"
                :stroke-width="14"
                :show-status-text="true"
                :status-text="passwordValid.statusText"
                :status="passwordValid.statusColor"
                :percentage="passwordValid.percentage"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="新密码确认"
              prop="comfirmPwd"
            >
              <el-input
                v-model="fd.comfirmPwd"
                class="c-form__input"
                type="password"
                placeholder="请输入确认密码"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </section>
    <div slot="footer">
      <el-button
        type="primary"
        @click="handleChangePassword"
      >
        确认
      </el-button>
      <el-button
        @click="closeDialog()"
      >
        取消
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import CheckPwdProgress from './CheckPwdProgress.vue';
import { passwordCheck, changepwd } from '@/features/feature.common.service.js';
import _ from 'lodash';
import config from '@/config';
export default {
  name: 'ChangePasswordDialog',
  components: {
    CheckPwdProgress
  },
  data () {
    const validatePassSame = (_vm, _formModelName, _newPwdName, _fields) => {
      return {
        validator: (rule, value, callback) => {
          const newPwd = _.get(_vm[_formModelName], _newPwdName, null);
          if (value && newPwd && value === newPwd) {
            callback(new Error(`【${_fields[0]}】与【${_fields[1]}】一致!`));
          } else {
            callback();
          }
        },
        trigger: ['blur', 'change']
      };
    };
    const validatePassDiff = (_vm, _formModelName, _newPwdName, _fields) => {
      return {
        validator: (rule, value, callback) => {
          const newPwd = _.get(_vm[_formModelName], _newPwdName, null);
          console.log(newPwd);
          if (value === '') {
            callback(new Error('请输入密码'));
          } else if (value !== newPwd) {
            callback(new Error('两次输入密码不一致!'));
          } else {
            callback();
          }
        },
        trigger: ['blur', 'change']

      };
    };
    const checkPwdValid = (_vm, _field, _passwordValidName) => {
      return {
        validator: (rule, value, callback) => {
          if (!value) return;
          const _passwordValid = _vm[_passwordValidName];
          passwordCheck(value).then(rsp => {
            _passwordValid.statusText = rsp.data.levelDesc;
            switch (rsp.data.level) {
              case 0:
              case 1:
              case 2:
              case 3:
                _passwordValid.percentage = 20;
                _passwordValid.statusColor = 'warning';
                break;
              case 4:
              case 5:
              case 6:
                _passwordValid.percentage = 40;
                _passwordValid.statusColor = 'exception';
                break;
              case 7:
              case 8:
              case 9:
                _passwordValid.percentage = 60;
                _passwordValid.statusColor = '';
                break;
              case 10:
              case 11:
              case 12:
                _passwordValid.percentage = 80;
                _passwordValid.statusColor = 'warning';
                break;
              default: // 其它异常 3000 +
                _passwordValid.percentage = 100;
                _passwordValid.statusColor = 'success';
            }
            if (rsp.data.pass) {
              callback();
            } else {
              callback(new Error('密码强度不足，建议使用数字和大小写字母的组合'));
            }
          });
        },
        trigger: ['blur', 'change']
      };
    };
    return {
      dialogShow: true, // 模态框dialog显示

      /* 表单参数 Start */
      fd: {
        oldPwd: '',
        newPwd: '',
        comfirmPwd: ''
      },
      /* 表单参数 End */

      /* 表单校验规则 Start */
      fdRules: {
        oldPwd: [
          this.$validUtils.required('原密码')
        ],
        newPwd: [
          this.$validUtils.required('新密码'),
          this.$HMValidator.minLength('新密码', 8),
          validatePassSame(this, 'fd', 'oldPwd', ['原密码', '新密码']),
          checkPwdValid(this, '新密码', 'passwordValid')
        ],
        comfirmPwd: [
          this.$validUtils.required('确认密码'),
          validatePassDiff(this, 'fd', 'newPwd', ['新密码', '确认密码'])
        ]
      },
      /* 表单校验规则 End */

      // 密码校验结果
      passwordValid: {
        statusText: null,
        percentage: 0,
        statusColor: null
      }
    };
  },
  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },
    /**
     * @description: 修改密码
     * @param {*}
     * @return {*}
     */
    handleChangePassword () {
      const _this = this;
      this.$refs.fd.validate((valid) => {
        if (valid) {
          changepwd(this.fd)
            .then(rsp => {
              this.$alert('修改成功，请重新登录系统！', '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                  _this.$HMCookies.unset(config.localTokenName); // 清除cookie
                  _this.$HMStoreService.removeUserinfo(); // 清除用户信息
                  _this.$HMStoreService.resetNavTab(); // 清除导航页签navtab
                  _this.$router.push('/login'); // 路由跳转登录页面
                }
              });
              this.$emit('closeDialog', '');
            })
            .catch(err => {
              console.error('修改密码错误！', err);
            });
        }
      });
    }
  },
  created () {
  }
};
</script>

<style scoped>
.o-dialog{
  line-height: normal;
}
</style>
